<template>
    <div id="editor">
        <editorChapterLongTop></editorChapterLongTop>
        <div class="main" :style="{ height: mianH + 'px' }">
            <div id="editor_chapter">
                <editorLongChapteroutline></editorLongChapteroutline>
            </div>
        </div>
        <vipPopup></vipPopup>
    </div>
</template>

<script>
import editorChapterLongTop from '@/components/long_novel/chapter/editor_long_top.vue' //编辑顶部
import editorLongChapteroutline from '@/components/long_novel/chapter/editor_long_chapteroutline.vue' //编辑大纲
import vipPopup from '@/components/vip_popup.vue' //vip页面
export default {
    components: {
        editorChapterLongTop, editorLongChapteroutline, vipPopup
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 80;
        }
    }
}
</script>

<style>
#editor {
    width: 100%;
    min-width: 1500px;
    height: 100vh;
    background-color: #F8F9FA;
}

#editor .main {
    width: 100%;
    min-width: 1500px;
    margin-top: 13px;
    display: flex;
}

#editor_chapter {
    flex: 1;
    height: 100%;
}
</style>